<template>
  <SocialLinks :socialLinks="socialLinks" />
</template>

<script>
import SocialLinks from "../../components/SocialLinks/SocialLinks.vue";

export default {
  name: "app",
  components: {
    SocialLinks
  },
  data() {
    return {
      socialLinks: JSON.parse(this.$options._parentVnode.data.props.socialLinks),
    };
  }
};
</script>
